export default __webpack_public_path__ + "static/media/css.6ac464f3.png";